import PropTypes from 'prop-types';
import React from 'react';

import httpClient from 'httpClient';

import AuthSearch from './AuthSearch';

function onUserSearch(includeSecondaryAccounts, includeServiceAccounts) {
  return (query, signal) => {
    return Promise.all([
      httpClient.get('/api/users', {
        signal,
        params: {includeSecondaryAccounts, login: query, exact: true},
      }),
      httpClient.get('/api/users', {
        signal,
        params: {includeSecondaryAccounts, includeServiceAccounts, login: query},
      }),
      httpClient.get('/api/users', {
        signal,
        params: {includeSecondaryAccounts, includeServiceAccounts, name: query},
      }),
      httpClient.get('/api/users', {
        signal,
        params: {includeSecondaryAccounts, includeServiceAccounts, email: query},
      }),
    ]);
  };
}

export default function UserSearch({
  includeSecondaryAccounts,
  includeServiceAccounts,
  disabled,
  ...props
}) {
  return (
    <AuthSearch
      itemKeyName="upn"
      onSearch={onUserSearch(includeSecondaryAccounts, includeServiceAccounts)}
      itemRenderer={user => ({
        text: user.upn,
        value: user.upn,
        content: (
          <React.Fragment key={user.upn}>
            <div className="text">{user.upn}</div>
            <div className="description">
              {user.displayName} {user.description && <>({user.description})</>}
            </div>
          </React.Fragment>
        ),
      })}
      noResultsMessage="No users found"
      disabled={disabled}
      {...props}
    />
  );
}

UserSearch.propTypes = {
  includeSecondaryAccounts: PropTypes.bool,
  includeServiceAccounts: PropTypes.bool,
  disabled: PropTypes.bool,
};

UserSearch.defaultProps = {
  includeSecondaryAccounts: false,
  includeServiceAccounts: false,
  disabled: false,
};
